import apiClient from './apiClient';

const ENDPOINT = '/Studio';

/**
 * Studio.API – Postman Studio klasörüne göre endpoint'ler.
 * Her fonksiyon Postman'deki metod ve endpoint adına sadıktır.
 */
export default {
  getOwnerStudio() {
    return apiClient.get(`${ENDPOINT}/GetOwnerStudio`);
  },
  getStudio(params) {
    return apiClient.get(`${ENDPOINT}/GetStudio`, { params });
  },
  getUserStudios() {
    return apiClient.get(`${ENDPOINT}/GetUserStudios`);
  },
  getStudioRoles() {
    return apiClient.get(`${ENDPOINT}/GetStudioRoles`);
  },
  getStudioUsers(params) {
    return apiClient.get(`${ENDPOINT}/GetStudioUsers`, { params });
  },
  getStudioUsersByRoles(params) {
    return apiClient.get(`${ENDPOINT}/GetStudioUsersByRoles`, { params });
  },
  getStudioPackages(params) {
    return apiClient.get(`${ENDPOINT}/GetStudioPackages`, { params });
  },
  getStudioPackagesForUser(params) {
    return apiClient.get(`${ENDPOINT}/GetStudioPackagesForUser`, { params });
  },
  getPackageRefCodes(params) {
    return apiClient.get(`${ENDPOINT}/GetPackageRefCodes`, { params });
  },
  getStudioUserInviteCodes(params) {
    // GET /Studio/GetStudioUserInviteCodes?studioId=...
    return apiClient.get(`${ENDPOINT}/GetStudioUserInviteCodes`, { params });
  },
  getStudioMemberInviteCodes(params) {
    return apiClient.get(`${ENDPOINT}/GetStudioMemberInviteCodes`, { params });
  },
  getStudioContracts(params) {
    return apiClient.get(`${ENDPOINT}/GetStudioContracts`, { params });
  },
  /**
   * GET /Studio/GetUserUnapprovedContracts
   * @param {object} params
   * @param {object} config axios config (örn: { skipAuthRedirect: true })
   */
  getUserUnapprovedContracts(params, config = {}) {
    return apiClient.get(`${ENDPOINT}/GetUserUnapprovedContracts`, { params, ...config });
  },
  /**
   * GET /Studio/GetUserContracts
   * @param {object} params
   * @param {object} config axios config (örn: { skipAuthRedirect: true })
   */
  getUserContracts(params, config = {}) {
    return apiClient.get(`${ENDPOINT}/GetUserContracts`, { params, ...config });
  },
  getUserContractsForAdmin(params) {
    return apiClient.get(`${ENDPOINT}/GetUserContractsForAdmin`, { params });
  },
  getMemberContracts(params) {
    return apiClient.get(`${ENDPOINT}/GetMemberContracts`, { params });
  },
  checkUserPermissionForStudio(params, config = {}) {
    return apiClient.get(`${ENDPOINT}/CheckUserPermissionForStudio`, { params, ...config });
  },
  addStudio(payload) {
    return apiClient.post(`${ENDPOINT}/AddStudio`, payload);
  },
  addStudioUser(payload) {
    return apiClient.post(`${ENDPOINT}/AddStudioUser`, payload);
  },
  addStudioPackage(payload) {
    return apiClient.post(`${ENDPOINT}/AddStudioPackage`, payload);
  },
  addPackageRefCode(payload) {
    return apiClient.post(`${ENDPOINT}/AddPackageRefCode`, payload);
  },
  addMemberPackage(payload) {
    return apiClient.post(`${ENDPOINT}/AddMemberPackage`, payload);
  },
  addStudioUserInviteCode(payload) {
    return apiClient.post(`${ENDPOINT}/AddStudioUserInviteCode`, payload);
  },
  confirmStudioUserInviteCode(code) {
    return apiClient.post(`${ENDPOINT}/ConfirmStudioUserInviteCode`, JSON.stringify(code), {
      headers: { 'Content-Type': 'application/json' },
    });
  },
  addStudioMemberInviteCode(payload) {
    return apiClient.post(`${ENDPOINT}/AddStudioMemberInviteCode`, payload);
  },
  addStudioContract(payload) {
    return apiClient.post(`${ENDPOINT}/AddStudioContract`, payload);
  },
  approveStudioContracts(payload) {
    return apiClient.post(`${ENDPOINT}/ApproveStudioContracts`, payload);
  },
  updateStudio(payload) {
    return apiClient.patch(`${ENDPOINT}/UpdateStudio`, payload);
  },
  updateStudioUser(payload) {
    return apiClient.patch(`${ENDPOINT}/UpdateStudioUser`, payload);
  },
  updateStudioPackage(payload) {
    return apiClient.patch(`${ENDPOINT}/UpdateStudioPackage`, payload);
  },
  updateStudioContract(payload) {
    return apiClient.patch(`${ENDPOINT}/UpdateStudioContract`, payload);
  },
  deleteStudioPackage(packageId) {
    return apiClient.delete(`${ENDPOINT}/DeleteStudioPackage`, {
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify(packageId),
    });
  },
  deletePackageRefCode(packageRefCodeId) {
    return apiClient.delete(`${ENDPOINT}/DeletePackageRefCode`, {
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify(packageRefCodeId),
    });
  },
  deleteStudioUserInviteCode(inviteCodeId) {
    return apiClient.delete(`${ENDPOINT}/DeleteStudioUserInviteCode`, {
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify(inviteCodeId),
    });
  },
  deleteStudioUser(studioUserId) {
    // DELETE /Studio/DeleteStudioUser (body: "studioUserId")
    return apiClient.delete(`${ENDPOINT}/DeleteStudioUser`, {
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify(studioUserId),
    });
  },
  deleteStudioMemberInviteCode(inviteCodeId) {
    return apiClient.delete(`${ENDPOINT}/DeleteStudioMemberInviteCode`, {
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify(inviteCodeId),
    });
  },
  deleteStudioContract(studioContractId) {
    return apiClient.delete(`${ENDPOINT}/DeleteStudioContract`, {
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify(studioContractId),
    });
  },

  // --- Studio Member Invite Code Records (internal / reporting) ---
  getMemberInviteCodeRecords(params) {
    // GET /Studio/GetMemberInviteCodeRecords?studioId=...
    return apiClient.get(`${ENDPOINT}/GetMemberInviteCodeRecords`, { params });
  },
};
